(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-tab-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mobile-slider-arrows').forEach(function (arrows) {
    const wrapper = arrows.closest('.mobile-slider-wrapper, grid-slider');
    if (!wrapper) return;

    const slider = wrapper.querySelector('.grid--mobile-slider');
    if (!slider) return;

    const prevBtn = arrows.querySelector('.mobile-slider-arrow--prev');
    const nextBtn = arrows.querySelector('.mobile-slider-arrow--next');

    function getSlideWidth() {
      const firstSlide = slider.querySelector('[data-grid-item]');
      if (!firstSlide) return slider.clientWidth;
      const gap = parseInt(window.getComputedStyle(slider).gap) || 0;
      return firstSlide.offsetWidth + gap;
    }

    function updateButtons() {
      if (prevBtn) prevBtn.disabled = slider.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        slider.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        slider.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
      });
    }

    slider.addEventListener('scroll', updateButtons);
    updateButtons();
  });
});

  } catch(e) { console.error(e); }
})();
})();
